import { DeliveryEta } from '@/types';
import { getParams } from '@/utils/params';
import { getUrl as getDesignerServiceUrl } from './fetchFromDesignerService';
import { getRequest } from './methods/getRequest';
import { requestToJSON } from './methods/requestToJSON';

export const fetchDeliveryETA = (productTypeId: string, printTypeIds: string[]) => {
  const { context, contextId, geoLocationCountry } = getParams();
  const params = new URLSearchParams({
    context,
    contextId,
    productTypeIds: productTypeId,
    locale: getParams().locale,
  });

  if (geoLocationCountry) {
    params.set('country', geoLocationCountry);
  }

  printTypeIds.forEach((printTypeId) => params.append('printTypeIds', printTypeId));

  return requestToJSON<DeliveryEta>(
    getRequest(`${getDesignerServiceUrl('deliveryETA')}/?${params}`)
  );
};
